module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "3em!important",
      "margin-bottom": "1.5em!important"
    }
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "text-align": "justify"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/07_forward#for",
      "id": "for"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/08_preface#pre",
      "id": "pre"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/09_acknowledgement#ack",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/10_abbreviations#abb",
      "id": "abb"
    }
  }, [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/11_chapter1#ch1",
      "id": "ch1"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/11_chapter1#ch1"
    }
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION TO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILITARY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_1",
      "id": "sec1-1"
    }
  }, [_vm._v("The Military Bridge")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_2",
      "id": "sec1-2"
    }
  }, [_vm._v("The Importance of Military Bridging")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_3",
      "id": "sec1-3"
    }
  }, [_vm._v("The Pedigree of the Bridge Builders")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_4",
      "id": "sec1-4"
    }
  }, [_vm._v("The Sappers as Bridge Builders")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_5",
      "id": "sec1-5"
    }
  }, [_vm._v("Types of Military Bridging")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_6",
      "id": "sec1-6"
    }
  }, [_vm._v("The Evolution of Equipment Bridging")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_7",
      "id": "sec1-7"
    }
  }, [_vm._v("The Design of Military Bridges")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/11_chapter1#sec1_8",
      "id": "sec1-8"
    }
  }, [_vm._v("The Load Classification of Bridges")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_chapter2#ch2",
      "id": "ch2"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("hapter")]), _vm._v(" 2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_chapter2#ch2"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDLE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GES TO THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INETEENTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_1",
      "id": "sec2-1"
    }
  }, [_vm._v("Edward I Invades Wales")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_2",
      "id": "sec2-2"
    }
  }, [_vm._v("Edward in Scotland")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_3",
      "id": "sec2-3"
    }
  }, [_vm._v("The Ordnance Trains")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_4",
      "id": "sec2-4"
    }
  }, [_vm._v("The Eighteenth Century")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_5",
      "id": "sec2-5"
    }
  }, [_vm._v("Wellesley in India")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_6",
      "id": "sec2-6"
    }
  }, [_vm._v("The Napoleonic Wars")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_7",
      "id": "sec2-7"
    }
  }, [_vm._v("The Founding of the Royal Engineer Establishment")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_8",
      "id": "sec2-8"
    }
  }, [_vm._v("The Bridging or Pontoon Trains")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_9",
      "id": "sec2-9"
    }
  }, [_vm._v("The Tin Pontoon")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_10",
      "id": "sec2-10"
    }
  }, [_vm._v("Congreve’s Trough")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_11",
      "id": "sec2-11"
    }
  }, [_vm._v("The Pasley Pontoon")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_12",
      "id": "sec2-12"
    }
  }, [_vm._v("The Blanshard Pontoon")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_13",
      "id": "sec2-13"
    }
  }, [_vm._v("Equipments of our Allies and Enemies")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_14",
      "id": "sec2-14"
    }
  }, [_vm._v("Two Unsuccessful Proposals")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_15",
      "id": "sec2-15"
    }
  }, [_vm._v("Inflatable Pontoons")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_16",
      "id": "sec2-16"
    }
  }, [_vm._v("The Afghanistan Campaign of 1839")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_17",
      "id": "sec2-17"
    }
  }, [_vm._v("The Sikh Wars of 1845 to 1849")]), _vm._v(" – "), _c('a', {
    attrs: {
      "href": "#/text/12_chapter2#sec2_18",
      "id": "sec2-18"
    }
  }, [_vm._v("Mrs Fitzherbert and a Brighton Bridge")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_chapter3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INETEENTH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_1",
      "id": "sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crimean War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_2",
      "id": "sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Engineer Train")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_3",
      "id": "sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indian Mutiny of 1857–1859")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_4",
      "id": "sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berthon’s Boat")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_5",
      "id": "sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Abyssinian War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_6",
      "id": "sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blood Pontoon")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_7",
      "id": "sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Royal Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_8",
      "id": "sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ashanti War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_9",
      "id": "sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Demise of the Engineer Train")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_10",
      "id": "sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clauson or Mark II Pontoon")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_11",
      "id": "sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridging Trestles")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_12",
      "id": "sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Light Bridge and Raft Equipment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_13",
      "id": "sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lock Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter3#sec3_14",
      "id": "sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The South African War of 1899")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_1",
      "id": "sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Turn of the Century")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_2",
      "id": "sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equipped for War?")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_3",
      "id": "sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wartime Expansion")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_4",
      "id": "sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sapper Re-equipment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_5",
      "id": "sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stock Spans")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_6",
      "id": "sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Canal Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_7",
      "id": "sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Bridging Operations")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_8",
      "id": "sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supply in the Field")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_9",
      "id": "sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Inglis")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_10",
      "id": "sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Triangular Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_11",
      "id": "sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Training for Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_12",
      "id": "sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Equipments")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_13",
      "id": "sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bridging of the Somme in 1917")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_14",
      "id": "sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advent of the Tank")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_15",
      "id": "sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Bridges Mark I and II")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_16",
      "id": "sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hopkins Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_17",
      "id": "sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle for Arras")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_18",
      "id": "sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emergence of Assault Bridging During the Final Advance")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_19",
      "id": "sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Victoria Cross")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_20",
      "id": "sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railway Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_21",
      "id": "sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridging Operations Outside NW Europe")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_22",
      "id": "sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operations in Italy")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_23",
      "id": "sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operations in Egypt and Palestine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter4#sec4_24",
      "id": "sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Campaign in Mesopotamia")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_chapter5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARS AT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTCHURCH")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_1",
      "id": "sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Barracks, Christchurch")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_2",
      "id": "sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martel Takes Command")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_3",
      "id": "sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lock Bridge and the Royal Engineer Tank")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_4",
      "id": "sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_5",
      "id": "sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Large Box Girder Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_6",
      "id": "sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Heavy Floating Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_7",
      "id": "sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martel Leaves Christchurch")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_8",
      "id": "sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Pontoon Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_9",
      "id": "sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Infantry Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_10",
      "id": "sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Folding Boat Equipment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_11",
      "id": "sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D C Bailey")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_12",
      "id": "sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Work of 17 Field Company RE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_13",
      "id": "sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bateman’s Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_14",
      "id": "sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stepping Stones")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_15",
      "id": "sec5-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mat Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_16",
      "id": "sec5-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kapok Assault Bridge Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_17",
      "id": "sec5-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Small Box Girder Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/15_chapter5#sec5_18",
      "id": "sec5-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of a Decade")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter6#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARMAMENT IN THE")]), _vm._v(" 1930s")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_1",
      "id": "sec6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lean Times at Christchurch")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_2",
      "id": "sec6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Large Box Girder Mark II")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_3",
      "id": "sec6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tide Begins to Turn")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_4",
      "id": "sec6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British Tanks Between the Wars")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_5",
      "id": "sec6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Pontoon Bridge for the 30s")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_6",
      "id": "sec6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Small Box Girder Bridge Mark III")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_7",
      "id": "sec6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foreign Exploitation")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_8",
      "id": "sec6-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Folding Boat Equipment Mark III")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_9",
      "id": "sec6-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Callender-Hamilton or Unit Construction Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_10",
      "id": "sec6-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W T Everall")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_11",
      "id": "sec6-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christchurch Crib")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_12",
      "id": "sec6-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assault Bridging before the War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_13",
      "id": "sec6-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dragon Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_14",
      "id": "sec6-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scissors Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_15",
      "id": "sec6-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wild Assault Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_16",
      "id": "sec6-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trackway Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/16_chapter6#sec6_17",
      "id": "sec6-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepared for War?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter7#ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTBREAK OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR AND THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AILEY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORY")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_1",
      "id": "sec7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September 1939")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_2",
      "id": "sec7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Procurement of RE Equipment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_3",
      "id": "sec7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sapper Armoury")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_4",
      "id": "sec7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Churchill Tank")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_5",
      "id": "sec7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Inglis Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_6",
      "id": "sec7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birth of the Bailey Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_7",
      "id": "sec7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Design Begins")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_8",
      "id": "sec7-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Testing the Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_9",
      "id": "sec7-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Design is Finalized")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_10",
      "id": "sec7-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manufacture")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_11",
      "id": "sec7-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mass Production")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_12",
      "id": "sec7-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bailey Pontoon Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_13",
      "id": "sec7-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bailey Suspension Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_14",
      "id": "sec7-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multi-Span Bailey Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_15",
      "id": "sec7-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Canal Lock Bailey")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_16",
      "id": "sec7-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bailey Retractable Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_17",
      "id": "sec7-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dual Carriageway Bailey")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_18",
      "id": "sec7-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bailey Railway Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_19",
      "id": "sec7-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The American Panel Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_20",
      "id": "sec7-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widened Bailey Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/17_chapter7#sec7_21",
      "id": "sec7-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Success Story")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter8#ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIPMENTS OF THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_1",
      "id": "sec8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scope of Sapper Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_2",
      "id": "sec8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Bridge Mark III")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_3",
      "id": "sec8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Briggs Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_4",
      "id": "sec8-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Butterley Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_5",
      "id": "sec8-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Flambo Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_6",
      "id": "sec8-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assault Bridging during the War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_7",
      "id": "sec8-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scissors Bridge 30ft, No 1")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_8",
      "id": "sec8-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tank Bridge 30ft, No 2")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_9",
      "id": "sec8-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tank Bridge, SBG")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_10",
      "id": "sec8-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79 Armoured Division and the Assault Engineers")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_11",
      "id": "sec8-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ARKs")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_12",
      "id": "sec8-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inglis Assault or Mobile Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_13",
      "id": "sec8-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bailey Mobile Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_14",
      "id": "sec8-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plymouth Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_15",
      "id": "sec8-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Brown Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_16",
      "id": "sec8-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dalton Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_17",
      "id": "sec8-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skid Bailey")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_18",
      "id": "sec8-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Track Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_19",
      "id": "sec8-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Equipments")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_20",
      "id": "sec8-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Class 50/60 Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_21",
      "id": "sec8-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Close Support Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_22",
      "id": "sec8-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indian Mat Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_23",
      "id": "sec8-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The PN Boat")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_24",
      "id": "sec8-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eastern Army Boat")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_25",
      "id": "sec8-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Infantry Assault Boat")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_26",
      "id": "sec8-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railway Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_27",
      "id": "sec8-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Equipments")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_28",
      "id": "sec8-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RSJ Span Railway Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_29",
      "id": "sec8-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plate Girder Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_30",
      "id": "sec8-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Standard Through Truss Railway Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_31",
      "id": "sec8-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unit Construction Railway Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_32",
      "id": "sec8-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Everall Sectional Truss Railway Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_33",
      "id": "sec8-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Callender-Hamilton Railway Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_34",
      "id": "sec8-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridge Trestles and Piers")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_35",
      "id": "sec8-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expedient Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/18_chapter8#sec8_36",
      "id": "sec8-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Role of the Royal Army Service Corps")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter9#ch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" - N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FRICA AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TALY")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_1",
      "id": "sec9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scope of Operations")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_2",
      "id": "sec9-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("France and Belgium, 1939–40")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_3",
      "id": "sec9-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mansion House Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_4",
      "id": "sec9-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridging in North Africa")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_5",
      "id": "sec9-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Italian Campaign")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_6",
      "id": "sec9-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Volturno Operation")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_7",
      "id": "sec9-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the Sangro")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_8",
      "id": "sec9-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rapido Crossing of May 1944")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_9",
      "id": "sec9-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ASAMFU Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_10",
      "id": "sec9-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Operation in Italy and the Crossing of the Po")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_11",
      "id": "sec9-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bailey During the Italian Campaign")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_12",
      "id": "sec9-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Railway Bridging During the Campaign")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/19_chapter9#sec9_13",
      "id": "sec9-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armoured Engineers in Italy")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter10#ch10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" - NW E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("urope and the")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_1",
      "id": "sec10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Campaign in North West Europe")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_2",
      "id": "sec10-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Overlord")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_3",
      "id": "sec10-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crossing of the Seine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_4",
      "id": "sec10-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advance to the Rhine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_5",
      "id": "sec10-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparations for the Rhine Crossing")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_6",
      "id": "sec10-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhine Crossing")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_7",
      "id": "sec10-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance from the Rhine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_8",
      "id": "sec10-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War in the Far East")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_9",
      "id": "sec10-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Initial Retreat")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_10",
      "id": "sec10-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operations in 1943")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_11",
      "id": "sec10-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Japanese Offensive in Spring 1944")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_12",
      "id": "sec10-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Allied Offensive of 1944")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_13",
      "id": "sec10-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crossing of the Chindwin")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_14",
      "id": "sec10-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tamu-Kalewa Road")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_15",
      "id": "sec10-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crossing of the Irrawaddy")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_16",
      "id": "sec10-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the River Shweli")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_17",
      "id": "sec10-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridging Improvisation")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_18",
      "id": "sec10-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advance to Rangoon")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/20_chapter10#sec10_19",
      "id": "sec10-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of the War")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter11#ch11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("H")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTWAR")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RA")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_1",
      "id": "sec11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postwar Expansion at Christchurch")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_2",
      "id": "sec11-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Postwar Programme")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_3",
      "id": "sec11-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Structural Materials")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_4",
      "id": "sec11-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Experimental Class 18 Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_5",
      "id": "sec11-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Experimental Light Alloy Pontoon")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_6",
      "id": "sec11-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Floating Equipments")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_7",
      "id": "sec11-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Light Assault Floating Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_8",
      "id": "sec11-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heavy Ferry")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_9",
      "id": "sec11-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heavy Assault Floating Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_10",
      "id": "sec11-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heavy Girder Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_11",
      "id": "sec11-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Extra Widened Bailey Bridge")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_12",
      "id": "sec11-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coles Bridging Crane")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_13",
      "id": "sec11-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postwar Railway Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_14",
      "id": "sec11-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sectional Plate Girder Railway Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_15",
      "id": "sec11-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Improvised Heavy Girder Railway Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_16",
      "id": "sec11-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Infantry Assault Boat Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_17",
      "id": "sec11-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Far East Assault Boat Raft")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_18",
      "id": "sec11-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 50 Ton Bridging Crib")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_19",
      "id": "sec11-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 500 Ton Bridge Test Rig")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/21_chapter11#sec11_20",
      "id": "sec11-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And what of MEXE?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter12#ch12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING FOR THE")]), _vm._v(" 1970s "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" 80s")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_1",
      "id": "sec12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Next Decade")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_2",
      "id": "sec12-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Class 16 Airportable Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_3",
      "id": "sec12-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 20ft Inflated Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_4",
      "id": "sec12-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amphibious Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_5",
      "id": "sec12-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The EWK-Gillois")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_6",
      "id": "sec12-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Amphibious Engineer Squadron")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_7",
      "id": "sec12-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Amphibious Bridging and Ferrying Equipment-M2")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_8",
      "id": "sec12-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 Amphibious Engineer Regiment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_9",
      "id": "sec12-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mexeflote")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_10",
      "id": "sec12-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Alloy")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_11",
      "id": "sec12-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Medium Girder Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_12",
      "id": "sec12-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Multi-Span MGB")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_13",
      "id": "sec12-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating MGB")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_14",
      "id": "sec12-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reinforced MGB")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_15",
      "id": "sec12-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sucess of MGB")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_16",
      "id": "sec12-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bailey Cable Reinforcement Kit")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_17",
      "id": "sec12-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End of an Era")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_18",
      "id": "sec12-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Westminster Abbey Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_19",
      "id": "sec12-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commericial Exploitation of Military Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_20",
      "id": "sec12-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mabey and Johnson Ltd")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_21",
      "id": "sec12-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mabey Super Bailey")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_22",
      "id": "sec12-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mabey Compact Bridge System")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_23",
      "id": "sec12-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mabey Universal Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_24",
      "id": "sec12-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mabel Compact Pontoons")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_25",
      "id": "sec12-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mabey Uniflote")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_26",
      "id": "sec12-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thos Storey (Engineers) Ltd")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_27",
      "id": "sec12-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storey Bailey Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_28",
      "id": "sec12-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acrow Panel Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_29",
      "id": "sec12-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Acrow Heavy Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_30",
      "id": "sec12-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Callender-Hamilton Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter12#sec12_31",
      "id": "sec12-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Williams Fairey Engineering Ltd")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter13#ch13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSAULT")]), _vm._v("/A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMOURED")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INCE THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_1",
      "id": "sec13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Origins of 32 Assault Regiment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_2",
      "id": "sec13-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Equipment Situation in 1945")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_3",
      "id": "sec13-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 3 Tank Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_4",
      "id": "sec13-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ARK Mark III")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_5",
      "id": "sec13-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 4 Tank Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_6",
      "id": "sec13-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Postwar Tank")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_7",
      "id": "sec13-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sapper Variants in the FV 200 Series")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_8",
      "id": "sec13-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gas ARK")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_9",
      "id": "sec13-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The FV 208 Bridgelayer and the No 5 Tank Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_10",
      "id": "sec13-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Churchill Mark VII AVRE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_11",
      "id": "sec13-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Churchill Linked ARK")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_12",
      "id": "sec13-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 3 Tank Bridge Mark II")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_13",
      "id": "sec13-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Centurion Tank")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_14",
      "id": "sec13-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 6 Tank Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_15",
      "id": "sec13-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Centurion Mark 5 AVRE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_16",
      "id": "sec13-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Centurion ARK")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_17",
      "id": "sec13-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAMP")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_18",
      "id": "sec13-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fortunes of 32 Regiment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_19",
      "id": "sec13-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chieftain Tank")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_20",
      "id": "sec13-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FV 4203 and the No 7 Tank Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_21",
      "id": "sec13-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 8 Armoured Vehicle Launched Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_22",
      "id": "sec13-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fascines")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_23",
      "id": "sec13-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inflatable Fascine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_24",
      "id": "sec13-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pipe Fascine")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_25",
      "id": "sec13-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The No 9 Armoured Vehicle Launched Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_26",
      "id": "sec13-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rebirth of 32 Armoured Engineer Regiment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_27",
      "id": "sec13-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At Last, a Chieftain AVRE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_28",
      "id": "sec13-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combination Bridging")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_29",
      "id": "sec13-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Close Support Squadron")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_30",
      "id": "sec13-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options for Change")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_31",
      "id": "sec13-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Equipments")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_32",
      "id": "sec13-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strategic Defence Review")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/23_chapter13#sec13_33",
      "id": "sec13-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vickers Armoured Bridgelayer")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter14#ch14",
      "id": "ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTWAR")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PERATIONS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_1",
      "id": "sec14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cessation of Hostilities")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_2",
      "id": "sec14-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhine Bridges")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_3",
      "id": "sec14-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artlenburg Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_4",
      "id": "sec14-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wadi Kuf Bridges")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_5",
      "id": "sec14-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sapper Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_6",
      "id": "sec14-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Korean War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_7",
      "id": "sec14-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Queens’ Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_8",
      "id": "sec14-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Falklands Campaign")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_9",
      "id": "sec14-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gulf War")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_10",
      "id": "sec14-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operations in Bosnia")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/24_chapter14#sec14_11",
      "id": "sec14-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridging in Nepal")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter15#ch15",
      "id": "ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING INTO THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTURE")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_1",
      "id": "sec15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Development Cycle")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_2",
      "id": "sec15-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking to the Future")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_3",
      "id": "sec15-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Operational Requirement")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_4",
      "id": "sec15-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carbon Fibre, a New Material")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_5",
      "id": "sec15-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mechanically Assisted Construction by Hand")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_6",
      "id": "sec15-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRAVE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_7",
      "id": "sec15-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABLE")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_8",
      "id": "sec15-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way Ahead for UK")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_9",
      "id": "sec15-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Industrial Participation")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_10",
      "id": "sec15-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bridging for the 1990s Equipment")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_11",
      "id": "sec15-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Amphibious Bridge M3")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_12",
      "id": "sec15-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Infantry Bridge")]), _vm._v(" – "), _c('span', {
    attrs: {
      "href": "#/text/25_chapter15#sec15_13",
      "id": "sec15-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To the Future")]), _vm._v(".")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_appendixA#appA",
      "id": "appA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" A")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/26_appendixA#appA",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRONOLOGICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIPMENTS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_appendixB#appB",
      "id": "appB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" B")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_appendixB#appB",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIEF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECHNICAL")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES ON")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("QUIPMENTS AND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERIALS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_appendixC#appC",
      "id": "appC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" C")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_appendixC#appC",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENIOR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPOINTMENTS AT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTCHURCH")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/29_appendixD#appD",
      "id": "appD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" D")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/29_appendixD#appD",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIGREE OF THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSAULT")]), _vm._v("/A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RMOURED")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGINEERS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/30_appendixE#appE",
      "id": "appE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" E")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/30_appendixE#appE",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTORIA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSSES WON IN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PERATIONS")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/31_appendixF#appF",
      "id": "appF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" F")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/31_appendixF#appF",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" US/FRG/UK B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIDGING FOR THE")]), _vm._v(" 1980s P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROJECT")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/32_bibliography#bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLOGRAPHY")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/33_index#ind",
      "id": "ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })])])])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af358e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/06_toc.vue
// module id = 69
// module chunks = 0